/* eslint-env jquery, browser */
// import debug from 'debug';
import metrics from 'modules/metrics';
import { main } from 'modules/locks';
import auth0 from 'auth0-js';
import bus from 'modules/npm-component/bus';

// const error = debug('auth0:sso');
const AUTH0_CLIENT_ID = window.APP_CONFIG.AUTH0_CLIENT_ID;
const AUTH0_DOMAIN = window.APP_CONFIG.AUTH0_DOMAIN;

const client = new auth0.Authentication({
  domain: AUTH0_DOMAIN,
  clientID: AUTH0_CLIENT_ID
});

client.getSSOData(false, (err, data) => {
  bus.emit('sso', data);
});

main.lock.on('signup ready', () => {
  metrics.lib().track('open:signup', { cateogry: 'lock' });
});

main.lock.on('signin ready', () => {
  metrics.lib().track('open:signin', { category: 'lock' });
});

export const login = (window.login = function() {
  metrics.lib().track('click:signin', { category: 'button' });
  main.show();
});

export const signup = (window.signup = function(btn, options) {
  const data = { category: 'button' };

  if (btn) {
    data.trackData = $(btn).data('track');
  }

  metrics.lib().track('click:signup', data);
  main.signup(options);
});



// WEBPACK FOOTER //
// ./src/modules/boot/sso/client.js